import {grey400} from 'material-ui/styles/colors';

const styles = {
    toggleDiv: {
        maxWidth: 300,
        marginTop: 40,
        marginBottom: 5
    },
    toggleLabel: {
        color: grey400,
        fontWeight: 100
    },
    buttons: {
        float: 'right'
    },
    saveButton: {
        marginLeft: 5
    },
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginBottom: 40,
        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/admin/AdminPage/AdminPage.css.js